import { AbsoluteContainer, AnnouncementsContainer } from "./style";
import Announcement from "./Announcement";
import {
  IAirtableValues,
  useAnnouncement,
} from "../../../hooks/api/announcement/useAnnouncement";
import { PWAAnnouncement } from "./PWAAnnouncement";

export function Announcements() {
  const announcements = useAnnouncement();

  return (
    <AbsoluteContainer>
      <AnnouncementsContainer>
        <PWAAnnouncement />
        {announcements.map((announcement: IAirtableValues) => (
          <Announcement key={announcement.key} announcement={announcement} />
        ))}
      </AnnouncementsContainer>
    </AbsoluteContainer>
  );
}
